import {LoadSearchForm} from "@modules/onBoarding/application/usecase/LoadSearchForm";
import {SearchCompany} from "@modules/onBoarding/application/usecase/SearchCompany";
import {SearchFormViewModelPresenter} from "@modules/onBoarding/presentation/presenter/SearchFormViewModelPresenter";
import {CompaniesViewModelPresenter} from "@modules/onBoarding/presentation/presenter/CompaniesViewModelPresenter";
import {BVDCompanyRepository} from "@modules/onBoarding/infrastructure/repository/BVDCompanyRepository";
import {BVDCompanyDao} from "@modules/onBoarding/infrastructure/dao/BVDCompanyDao";


const searchFormPresenter = new SearchFormViewModelPresenter();
const loadSearchCompanyForm = new LoadSearchForm(searchFormPresenter);

const companyDao = new BVDCompanyDao();
const companyRepository = new BVDCompanyRepository(companyDao);
const companyPresenter = new CompaniesViewModelPresenter();
const searchCompany = new SearchCompany(companyRepository, companyPresenter);

export {
    loadSearchCompanyForm,
    searchCompany,
};
